import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { PootsyTitle } from './DesignFunctions'
import SignInForm from './SignInForm'

export default class Login extends Component {

	render() {
		let { t } = this.context
		return (
			<div className="Login">
				<PootsyTitle title={t('login_header')}/>
				<div className="create-account-prompt">
					{t('create_account_prompt')} <Link to="/auth/signup"
													   className="login-link">{t('create_account')}</Link>
				</div>
				<SignInForm/>
			</div>
		)
	}
}

Login.contextTypes = { t: PropTypes.func }


// WEBPACK FOOTER //
// ./src/components/Login.js